import { Modal } from 'antd';
import { geAndUsStates } from '../data';
import { collectInfoSubmit } from '@/service';

export const getStateList = (shortName: string) =>
    geAndUsStates[shortName].map((item) => ({
        label: item.name,
        value: item.name,
    }));

function removeProperty(obj: { [key: string]: any }) {
    Object.keys(obj).forEach((item) => {
        if (obj[item] === '' || obj[item] === undefined || obj[item] === null || obj[item] === 'null') delete obj[item];
    });
    return obj;
}

export interface ValuesType {
    firstName: string;
    lastName: string;
    country: string;
    state: string;
    city: string;
    email: string;
    phone: string;
    zipCode: string;
    installSite: ChangeType;
    installSiteOthers: string;
    appliances: string;
    installmentPayment: { value: 'Yes' | 'No' };
    phoneDay: ChangeType | undefined;
    phoneTime: ChangeType | undefined;
    phoneTimeOthers: string | undefined;
    product: any[];
    channel: string | undefined;
    applicationSence?: any;
}
type SelectType = {
    value: string;
    label: string;
    key: string;
};
type ChangeType = {
    value: string;
    desc?: string;
};

type FnType = (value: boolean) => void;

export const onFinishParams = async (
    values: ValuesType,
    setIsLoading: FnType,
    locale: any,
    gtm: any[],
    formInstance: any,
    activityId: string,
    setCommSuccVisible: FnType,
) => {
    let prepParams;
    if (['us', 'ca'].includes(locale)) {
        let productStr = '';
        values?.product?.map((list: any, k: number) => {
            productStr += `${k > 0 ? ', ' : ''}${list?.label}`;
        });
        prepParams = {
            installSite: values.installSite.value,
            installSiteOthers: values.installSite?.desc || '',
            phoneDay: values.phoneDay?.value || '',
            installmentPayment: values.installmentPayment?.value || '',
            phoneTime: values.phoneTime?.value || '',
            phoneTimeOthers: values.phoneTime?.desc || '',
            crowdFundingId: activityId,
            product: productStr,
        };
    } else {
        const { firstName, lastName, email, phone } = values;
        prepParams = {
            firstName: firstName.trim(),
            lastName: lastName.trim(),
            email: email.trim(),
            phone: phone.trim(),
            // city: city.trim(),
            crowdFundingId: activityId,
        };
    }
    removeProperty(prepParams);

    // 提交参数
    const params = { ...values, ...prepParams };
    setIsLoading(true);

    try {
        const res: any = await collectInfoSubmit(params);
        setIsLoading(false);
        if (Number(res.code) == 0) {
            setCommSuccVisible(true);
            gtm.push({
                event: 'uaEvent',
                event_name: 'pre_order_submit',
                button_name: 'submit',
                status: 'success',
            });
            formInstance.resetFields();
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'pre_order_submit',
                button_name: 'submit',
                status: 'fail',
            });
            Modal.error({
                content: res.message,
            });
        }
        if (['us', 'ca', 'de', 'fr', 'uk', 'eu'].includes(locale)) {
            // @ts-ignore
            window?.fbq('track', 'CompleteRegistration');
        }
    } catch (err: any) {
        setIsLoading(false);
    }
};

export const toMM100GetQuote = (locale: string) => {
    const { protocol, host } = window.location;
    const href = `${protocol}//${host}`;
    window.open(`${href}/${locale}/ecoflow-power-kits/series/get-a-quote`);
};

export const selectOptionItemStyle = {
    height: '44x',
    'line-height': '44px',
};
